import { tunaEvent } from "@app/tuna";

export const CONTROLS_EVENTS = {
  TRUST_CENTER_CLICK: "controls.trust_center_click",
  EXPORT_PDF_REPORT_CLICK: "controls.export_pdf_report_click",
  PROVISION_DEDICATED_STACK_CLICK: "controls.provision_dedicated_stack_click",
  CONTROL_OPENED: "controls.control_opened",
} as const;

export function controlsEvent(
  eventName: (typeof CONTROLS_EVENTS)[keyof typeof CONTROLS_EVENTS],
  payload?: Record<string, unknown>,
): void {
  tunaEvent(eventName, payload ? JSON.stringify(payload) : null);
}
